import React, { useEffect, useState } from 'react';
import Card from '../Card';
import styles from './plist.module.css';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { Link, useLocation } from 'react-router-dom';
import Navbar from '../NavbarFooter/Navbar';
import Footer from '../NavbarFooter/Footer';
import axios from 'axios';
const Fuse = require('fuse.js'); 


function SearchResults(props) {
  const fuseOptions = {
    keys: ['name', 'details'],
  };

  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState(location.state?.searchQuery || '') 

  const [searchData, setSearchData] = useState([]);
  const [data, setData] = useState([]);
  const [colorChange, setColorchange] = useState('');

  const search = (searchPattern) => {
    const fuse = new Fuse(data, fuseOptions);
    return fuse.search(searchPattern).map(result => result);
  };

  const [text, setText] = useState('Loading');


  useEffect(() => {
    let timeoutId;

    axios.get('https://sportsblendserver.netlify.app/.netlify/functions/api/displayAllProducts')
      .then((res) => {
        setData(res.data);
        timeoutId = setTimeout(() => {
          if (searchData.length === 0) {
            setText('No product found!');
          }
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
        setText('Loading...');
      });

    return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
  }, []);


  function searchFunction(){

    if (data.length > 0) {
      const results = search(searchQuery);
      console.log(results)
      setSearchData(results);
    }
  }
  useEffect(() => {

    searchFunction();
  
  }, [data]);

  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange('rgb(70, 70, 70)');
    } else {
      setColorchange('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNavbarColor);
    return () => {
      window.removeEventListener('scroll', changeNavbarColor);
    };
  }, []);



  return (
    <div className='mpBG'>
      <Navbar bgcolor={colorChange} />
      <div className={styles.secDiv}>
        <div style={{width:'80%', height:'70px', justifySelf:'center', alignItems:'center',margin:'auto',paddingRight:'20px', marginTop:'10vh',display:'flex', backgroundColor:'white'}}>
          <input
          style={{width:'100%', height:'100%', paddingLeft:'20px', fontSize:'1.2rem', backgroundColor:'transparent', border:0}}
            type="text"
            placeholder="Search..."
            onChange={(e) =>{
              setSearchQuery(e.target.value)  
            }
            } 
          />
          <button style={{backgroundColor:'transparent',border:0, cursor:'pointer'}}>
            <FontAwesomeIcon icon={faSearch} style={{fontSize:'1rem', fontWeight:'800'}} onClick={searchFunction}
             />
          </button>
        </div>
        <h1 className={styles.searchHero}>Search results</h1>
        <div className={styles.cardsContainer}>
          {searchData.length > 0 ? (
            searchData.map((item) => {
              if (!item) return null;
              const { _id, name, price, photo } = item;
              return (
                <div key={_id}>
                  <Link to={`/productCustomize/${_id}`} className='card-link'>
                    <Card
                      customize={_id === '65380ddac794fcf8d4778bd5'}
                      name={name}
                      price={price}
                      cardImage={photo && photo.length > 0 ? `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo[0]}` : ''}
                      overlayImage={photo && photo.length > 0 ? `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo[1]}` : ''}
                    />
                  </Link>
                </div>
              );
            })
          ) : (
            <p style={{marginBottom:'50vh'}}>{text}</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SearchResults;
